// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qYCe","importantInfo":"styles_importantInfo__3Z3fy"};